import { render, staticRenderFns } from "./FavoriteLink.vue?vue&type=template&id=7f8d6fc6&scoped=true&"
import script from "./FavoriteLink.vue?vue&type=script&lang=js&"
export * from "./FavoriteLink.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteLink.vue?vue&type=style&index=0&id=7f8d6fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8d6fc6",
  null
  
)

export default component.exports